import React, { memo, useState } from "react";
import cn from "clsx";
import { useTranslation } from "react-i18next";
import ProductHighlights from "./productHighlights";

const MobileHighlights = () => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const { t } = useTranslation("productDetails");

  const handleToggleAccordion = () => setIsAccordionOpen(!isAccordionOpen);

  return (
    <div
      className={cn(
        "product_information",
        isAccordionOpen ? "open_prod_info" : "close_prod_info"
      )}
    >
      <div className="title" onClick={handleToggleAccordion}>
        <h5>{t("productInformation")}</h5>
      </div>
      <div className="content">
        <ProductHighlights />
      </div>
    </div>
  );
};

export default memo(MobileHighlights);
